import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavbarDashbord } from './navbarDashbord';
import { History, ShoppingCart, UserPlus, MessageSquare, RefreshCcw, ArrowRight, Calendar } from 'lucide-react';
import '../styles/admin.css';

export function PageHistorique() {
    const navigate = useNavigate();
    const [viewMode, setViewMode] = useState('today'); // 'today' or 'yesterday'
    
    const todayStr = new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayStr = yesterday.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

    const initialTodayItems = [
        { id: 1, type: 'order', title: 'Nouvelle commande #10042', user: 'Yassine Karim', time: '14:30', amount: '+8,400 MAD', icon: <ShoppingCart size={18} />, color: 'var(--admin-success)', route: '/pageCommandes' },
        { id: 2, type: 'comment', title: 'Nouveau commentaire sur LG AC09BK', user: 'Mounia Drissi', time: '11:15', status: 'En attente', icon: <MessageSquare size={18} />, color: 'var(--admin-warning)', route: '/pageCommentaires?climatiseurId=1&highlight=2' },
        { id: 3, type: 'user', title: 'Nouvelle inscription client', user: 'Anas Bennani', time: '09:45', status: 'Actif', icon: <UserPlus size={18} />, color: 'var(--admin-primary)', route: '/pageComptes' },
        { id: 4, type: 'update', title: 'Mise à jour du catalogue', user: 'Admin', time: '08:00', details: '12 produits modifiés', icon: <RefreshCcw size={18} />, color: 'var(--admin-secondary)', route: '/pageClimatisseurs' },
    ];

    const yesterdayItems = [
        { id: 101, type: 'order', title: 'Commande livrée #10038', user: 'Fatima Zahra', time: '18:20', amount: '+12,500 MAD', icon: <ShoppingCart size={18} />, color: 'var(--admin-success)', route: '/pageCommandes' },
        { id: 102, type: 'update', title: 'Nouveau produit ajouté', user: 'Admin', time: '16:05', details: 'Samsung WindFree v2', icon: <RefreshCcw size={18} />, color: 'var(--admin-secondary)', route: '/pageClimatisseurs' },
        { id: 103, type: 'comment', title: 'Avis client validé', user: 'Sami Loukili', time: '10:30', status: 'Approuvé', icon: <MessageSquare size={18} />, color: 'var(--admin-success)', route: '/pageCommentaires?climatiseurId=2' },
    ];

    const [historyItems, setHistoryItems] = useState(initialTodayItems);

    const loadYesterday = () => {
        if (viewMode === 'today') {
            setViewMode('yesterday');
            setHistoryItems([...initialTodayItems, ...yesterdayItems]);
        }
    };

    return (
        <div className="admin-layout">
            <NavbarDashbord />
            <main className="admin-main-content">
                <header className="admin-header">
                    <div className="admin-title-group">
                        <h1 style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <History size={32} color={viewMode === 'today' ? "var(--admin-secondary)" : "var(--admin-primary)"} />
                            {viewMode === 'today' ? "Historique du Jour" : "Historique Étendu"}
                        </h1>
                        <p>Activités enregistrées pour le <strong>{viewMode === 'today' ? todayStr : `Période récente (${yesterdayStr} - ${todayStr})`}</strong>.</p>
                    </div>
                </header>

                <div className="admin-table-container" style={{ marginTop: '30px', padding: '0', background: 'transparent', boxShadow: 'none' }}>
                    <div className="history-timeline" style={{ display: 'grid', gap: '20px' }}>
                        {historyItems.map((item) => (
                            <div 
                                key={item.id} 
                                className="history-card"
                                style={{
                                    background: 'white',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    boxShadow: 'var(--admin-shadow)',
                                    border: '1px solid var(--admin-border)',
                                    transition: 'transform 0.2s ease',
                                    cursor: 'pointer'
                                }}
                                onClick={() => navigate(item.route)}
                            >
                                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                    <div style={{ width: '45px', height: '45px', borderRadius: '12px', backgroundColor: `${item.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.color }}>
                                        {item.icon}
                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '800', color: 'var(--admin-primary)' }}>{item.title}</h4>
                                        <p style={{ margin: '2px 0 0', fontSize: '0.8rem', color: 'var(--admin-text-muted)' }}>
                                            Par {item.user} • <strong>{item.time}</strong>
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
                                    {item.amount && <span style={{ fontWeight: '900', color: 'var(--admin-secondary)', fontSize: '1rem' }}>{item.amount}</span>}
                                    {item.status && (
                                        <span style={{ 
                                            padding: '4px 12px', 
                                            borderRadius: '20px', 
                                            fontSize: '0.7rem', 
                                            fontWeight: '700', 
                                            backgroundColor: `${item.color}15`, 
                                            color: item.color,
                                            textTransform: 'uppercase'
                                        }}>
                                            {item.status}
                                        </span>
                                    )}
                                    <button 
                                        className="btn-icon" 
                                        style={{ borderRadius: '50%' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(item.route);
                                        }}
                                    >
                                        <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {viewMode === 'today' && (
                        <div style={{ marginTop: '40px', textAlign: 'center' }}>
                            <button 
                                onClick={loadYesterday}
                                style={{ 
                                    padding: '12px 30px', 
                                    borderRadius: '30px', 
                                    border: '2px solid var(--admin-primary)', 
                                    background: 'transparent', 
                                    color: 'var(--admin-primary)', 
                                    fontWeight: '800', 
                                    fontSize: '0.9rem',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <Calendar size={18} />
                                Charger l'historique d'hier
                            </button>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}
